import { useEffect, useRef } from 'react';
import { Html5Qrcode } from 'html5-qrcode';

const ELEMENT_ID = 'qr-reader';

// Composant fin autour de html5-qrcode (deja utilise cote SIP pour le scan QR/
// code-barres, cf. CLAUDE.md du frontend Angular) : demarre la camera au montage,
// l'arrete au demontage, et remonte chaque decodage via onScan. Ne gere pas l'etat
// resultat/erreur lui-meme, ca reste au composant parent (App.js).
function QrScanner({ onScan, onError }) {
  // Chaine de promesses stockee dans un ref (donc stable a travers le double
  // montage de React StrictMode en dev, qui reutilise la meme instance de
  // composant). Sans ca, le montage/nettoyage/remontage immediat de StrictMode
  // demarre un second Html5Qrcode sur le meme div#qr-reader avant que le premier
  // n'ait fini de s'arreter : les deux instances se marchent dessus sur le meme
  // <video> et le navigateur leve "play() request was interrupted because the
  // media was removed from the document." En chainant chaque montage/nettoyage
  // sur cette promesse partagee, une instance ne demarre jamais avant que la
  // precedente soit completement arretee.
  const chaineRef = useRef(Promise.resolve());

  useEffect(() => {
    let annule = false;
    let scanner = null;
    let demarreAvecSucces = false;
    let stoppe = false;
    let decodeTraite = false;

    // stop() ne doit jamais etre appele plus d'une fois ni avant que start() se
    // soit reellement resolu : html5-qrcode leve "Cannot stop, scanner is not
    // running or paused." dans les deux cas.
    const arreterUneFois = () => {
      if (stoppe || !scanner) {
        return Promise.resolve();
      }
      stoppe = true;
      return scanner.stop().catch(() => {});
    };

    chaineRef.current = chaineRef.current.then(async () => {
      if (annule) return;
      scanner = new Html5Qrcode(ELEMENT_ID);
      try {
        await scanner.start(
          { facingMode: 'environment' },
          { fps: 10, qrbox: { width: 250, height: 250 } },
          (texteDecode) => {
            if (decodeTraite) return;
            decodeTraite = true;
            arreterUneFois().finally(() => onScan(texteDecode));
          },
          () => {
            // Erreur de decodage par frame (aucun QR dans l'image) : bruit normal,
            // ne pas remonter au parent sous peine de spammer un message d'erreur.
          }
        );
        demarreAvecSucces = true;
      } catch (err) {
        if (!annule) {
          onError(
            "Impossible d'accéder à la caméra. Vérifiez que l'accès caméra est autorisé pour ce site."
          );
        }
        // eslint-disable-next-line no-console
        console.error('Erreur de démarrage du scanner QR :', err);
      }
    });

    return () => {
      annule = true;
      chaineRef.current = chaineRef.current.then(() => {
        if (demarreAvecSucces) {
          return arreterUneFois();
        }
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div id={ELEMENT_ID} className="qr-reader" />;
}

export default QrScanner;
